class CreditLengthChange {
    constructor(key, date, value){
        this.key = key;
        this.date = date;
        this.value = value;
        console.log('new object');
    }
}

export default CreditLengthChange;